import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { AudioTrack } from '../types/instance';

export const useOnCurrentAudioTrackChanged = (
    onCurrentAudioTrackChanged?: (playingState: AudioTrack | undefined) => void
) => {
    useInstanceEffect(
        (instance) => {
            if (onCurrentAudioTrackChanged) {
                return instance.onCurrentAudioTrackChange(onCurrentAudioTrackChanged);
            }
        },
        [onCurrentAudioTrackChanged]
    );
};
